import styled from "@emotion/styled/macro";
import { Typography } from "@sunrun/experience-ui-components";
import plusIcon from "../../assets/images/plus.svg";
import checkIcon from "../../assets/images/check.svg";

type AddPillProps = {
  disabled: boolean;
  itemAdded: boolean;
  toggleAdded: () => void;
  ariaLabel?: string;
  // When true, the pill is rendered as non-interactive and forced to the
  // "Added" visual. Used for required accessories that cannot be removed.
  locked?: boolean;
};

const AddPill = ({
  itemAdded,
  toggleAdded,
  disabled,
  ariaLabel,
  locked = false,
}: AddPillProps) => {
  const showAddedVisual = locked || itemAdded;
  const isDisabled = disabled && !locked;
  return (
    <AddAccessoryOrProductPill
      added={showAddedVisual}
      $locked={locked}
      onClick={locked ? undefined : toggleAdded}
      disabled={isDisabled}
      aria-disabled={locked ? "true" : undefined}
      aria-label={ariaLabel}
      data-testid={`add-pill`}
    >
      <Typography color={showAddedVisual ? "white" : undefined}>
        {showAddedVisual ? "Added" : "Add"}
      </Typography>
      <PillIcon iconUrl={showAddedVisual ? checkIcon : plusIcon} />
    </AddAccessoryOrProductPill>
  );
};

const AddAccessoryOrProductPill = styled.button<{
  added: boolean;
  $locked?: boolean;
}>`
  margin: 8px 8px 0 0;
  width: 84px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;
  gap: 4px;
  border: 1px solid #1f2647;
  border-radius: 24px;
  cursor: ${(props) => (props.$locked ? "not-allowed" : "pointer")};
  user-select: none;
  background: ${(props) => (props.added ? "#1F2647" : "none")};
  > div {
    color: ${(props) => (props.added ? "#fff" : "#1F2647")};
  }

  &:disabled {
    cursor: ${(props) => (props.$locked ? "not-allowed" : "progress")};
  }
`;

const PillIcon = styled.div<{ iconUrl: string }>`
  height: 10px;
  width: 10px;
  background: ${(props) =>
    `rgba(0,0,0,0) url(${props.iconUrl}) no-repeat center`};
`;

export { AddPill };
